import React, { useState } from 'react';
import { companyInfo } from '../../constants/data';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    const formPayload = {
      access_key: 'cb37dbbb-8062-4285-bc45-571cf3d996a9', // Replace with actual API key
      subject: `New Contact Form Submission from ${formData.name}`,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      service: formData.service,
      message: formData.message
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formPayload)
      });

      const result = await response.json();
      
      if (result.success) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Form submission error:', error);
    } finally {
      setSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  return (
    <div className="py-5">
      <div className="container-fluid">
        {/* Page Header */}
        <div className="row mb-5">
            <div className="col-12 text-center mb-5">
            <h1 className="display-4 fw-bold mb-3">Contact Us</h1>
            <p className="lead text-muted">Get in touch with our team for any inquiries or service requests</p>
            </div>
        </div>

        <div className="row">
          {/* Contact Form */}
          <div className="col-lg-7 mb-5 mb-lg-0">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-5">
                <h3 className="mb-4">Send us a Message</h3>
                
                {submitStatus === 'success' && (
                  <div className="alert alert-success alert-dismissible fade show" role="alert">
                    <i className="bi bi-check-circle me-2"></i>
                    Thank you! Your message has been sent successfully.
                    <button type="button" className="btn-close" onClick={() => setSubmitStatus(null)}></button>
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    There was an error sending your message. Please try again or call us directly.
                    <button type="button" className="btn-close" onClick={() => setSubmitStatus(null)}></button>
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="name" className="form-label">Full Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">Email Address *</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="phone" className="form-label">Phone Number *</label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="service" className="form-label">Service Required</label>
                      <select
                        className="form-select"
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                      >
                        <option value="">Select a service</option>
                        <option value="rental">Forklift Rental</option>
                        <option value="parts">Spare Parts</option>
                        <option value="maintenance">Maintenance Service</option>
                        <option value="training">Operator Training</option>
                        <option value="sales">Forklift Sales</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="message" className="form-label">Message *</label>
                    <textarea
                      className="form-control"
                      id="message"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg w-100"
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Contact Information & Map */}
          <div className="col-lg-5">
            <div style={{top: '20px'}}>
              {/* Contact Info */}
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-body p-4">
                  <h4 className="mb-4">Contact Information</h4>
                  
                  <div className="d-flex mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-geo-alt text-primary fs-4"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Address</h6>
                      <p className="text-muted mb-0">{companyInfo.address}</p>
                    </div>
                  </div>
                  
                  <div className="d-flex mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-telephone text-primary fs-4"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Phone</h6>
                      <p className="text-muted mb-0">{companyInfo.phone}</p>
                    </div>
                  </div>
                  
                  <div className="d-flex mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-envelope text-primary fs-4"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Email</h6>
                      <p className="text-muted mb-0">{companyInfo.email}</p>
                    </div>
                  </div>
                  
                  <div className="d-flex">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '50px', height: '50px'}}>
                      <i className="bi bi-clock text-primary fs-4"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Working Hours</h6>
                      <p className="text-muted mb-0">{companyInfo.workingHours}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Contact */}
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  <h4 className="mb-3">Quick Contact</h4>
                  <div className="d-grid gap-2">
                    <a href={`tel:${companyInfo.primaryphone}`} className="btn btn-primary">
                      <i className="bi bi-telephone me-2"></i>Call Now
                    </a>
                    <a href={`https://wa.me/${companyInfo.primaryphone.replace(/\D/g, '')}`} className="btn btn-success">
                      <i className="bi bi-whatsapp me-2"></i>WhatsApp
                    </a>
                    <a href={`mailto:${companyInfo.email}`} className="btn btn-outline-primary">
                      <i className="bi bi-envelope me-2"></i>Send Email
                    </a>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="card border-0 shadow-sm mt-4">
                <div className="card-body p-4">
                  <h4 className="mb-3">
                    <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                    Our Location
                  </h4>
                  <div className="ratio ratio-16x9">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7338.9873239414865!2d77.49516586969698!3d23.115624231742537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c4659e0f9f6c5%3A0x2302048866ebf472!2sSamardha%20Kaliyasot%2C%20Madhya%20Pradesh%20462047!5e0!3m2!1sen!2sin!4v1769861482433!5m2!1sen!2sin" 
                        width="600" height="450" 
                        style={{ border: 0 }} 
                        allowFullScreen="" loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade" 
                        title="Aarav Enterprises Location"></iframe>
                  </div>
                  <div className="mt-3">
                    <a 
                      href="https://www.google.com/maps/dir//Shop+4+Sharma+Complex+Samardha+Bhopal+462047" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm w-100"
                    >
                      <i className="bi bi-signpost-split me-2"></i>
                      Get Directions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;